import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "remove-photo",
  "use": "remove-photo-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"remove-photo\">\n<path d=\"M9.00033 0.666672C4.39616 0.666672 0.666992 4.39584 0.666992 9.00001C0.666992 13.6042 4.39616 17.3333 9.00033 17.3333C13.6045 17.3333 17.3337 13.6042 17.3337 9.00001C17.3337 4.39584 13.6045 0.666672 9.00033 0.666672ZM13.167 9.83334H4.83366V8.16667H13.167V9.83334Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol